<p-toast></p-toast>

<div class="login-container">
  <div class="login-panel p-fluid">
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }" *ngIf="isLoading"></p-progressBar>

    <div class="logo-container">
      <img src="assets/shopping_online.png" height="60" alt="App Logo">
      <h2 class="app-title">TATC Digital Hub AI Workbench</h2>
      <p class="subtitle">Secure access for Tamer employees and supplier partners.</p>
    </div>

    <div class="login-tabs" *ngIf="!showOtpStep">
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'tamer'"
        (click)="switchTab('tamer')">
        Tamer Employees
      </button>
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'supplier'"
        (click)="switchTab('supplier')">
        Suppliers
      </button>
    </div>

    <div *ngIf="!showOtpStep && activeTab === 'tamer'" class="auth-section">
      <div class="section-copy">
        <h3>Tamer Employee Access</h3>
        <p>Use the internal identity provider to continue with your corporate SSO account.</p>
      </div>

      <p-button
        icon="pi pi-lock"
        styleClass="auth-button tamer-button"
        label="Continue with Tamer SSO"
        (onClick)="onSamlLogin()"
        [loading]="isLoading">
      </p-button>
    </div>

    <div *ngIf="!showOtpStep && activeTab === 'supplier'" class="auth-section">
      <div class="section-copy">
        <h3>Supplier Access</h3>
        <p>Use Google, Microsoft, or your supplier password account. Every supplier login is verified with an email OTP.</p>
      </div>

      <div class="provider-grid">
        <p-button
          icon="pi pi-google"
          styleClass="auth-button provider-button google-button"
          label="Continue with Google"
          (onClick)="onGoogleLogin()"
          [loading]="isLoading">
        </p-button>

        <p-button
          icon="pi pi-microsoft"
          styleClass="auth-button provider-button microsoft-button"
          label="Continue with Microsoft"
          (onClick)="onMicrosoftLogin()"
          [loading]="isLoading">
        </p-button>

        <p-button
          icon="pi pi-envelope"
          styleClass="auth-button provider-button email-toggle-button"
          label="Email and Password"
          (onClick)="openSupplierEmailForm()"
          [outlined]="!showSupplierEmailForm"
          [loading]="isLoading">
        </p-button>
      </div>

      <form
        *ngIf="showSupplierEmailForm"
        (ngSubmit)="onEmailSignIn(supplierLoginForm)"
        #supplierLoginForm="ngForm"
        class="supplier-form">
        <div class="field">
          <label for="email">Supplier Email Address</label>
          <input
            id="email"
            type="email"
            pInputText
            [(ngModel)]="email"
            name="email"
            required
            email
            #emailCtrl="ngModel"
            placeholder="name@your-company.com" />
          <small *ngIf="emailCtrl.invalid && (emailCtrl.dirty || emailCtrl.touched)" class="p-error">
            <span *ngIf="emailCtrl.errors?.['required']">Email is required.</span>
            <span *ngIf="emailCtrl.errors?.['email']">Enter a valid email address.</span>
          </small>
        </div>

        <div class="field">
          <label for="password">Password</label>
          <p-password
            id="password"
            [(ngModel)]="password"
            name="password"
            placeholder="Password"
            [toggleMask]="true"
            [feedback]="false"
            [style]="{ width: '100%' }"
            required
            #passwordCtrl="ngModel">
          </p-password>
          <small *ngIf="passwordCtrl.invalid && (passwordCtrl.dirty || passwordCtrl.touched)" class="p-error">
            Password is required.
          </small>
        </div>

        <div class="form-actions">
          <p-button
            label="Sign In"
            type="submit"
            styleClass="auth-button primary-action"
            [loading]="isLoading">
          </p-button>

          <p-button
            label="Create Password Account"
            type="button"
            styleClass="auth-button secondary-action"
            [outlined]="true"
            [loading]="isLoading"
            (onClick)="onCreateSupplierPassword(supplierLoginForm)">
          </p-button>
        </div>

        <button type="button" class="text-link" (click)="onForgotPassword()">
          Forgot your password?
        </button>
      </form>
    </div>

    <div *ngIf="showOtpStep" class="auth-section otp-section">
      <div class="section-copy">
        <h3>Supplier OTP Verification</h3>
        <p>Enter the one-time password sent to <strong>{{ otpMaskedEmail || email }}</strong>.</p>
        <p *ngIf="otpExpiresAt" class="otp-meta">Expires at {{ otpExpiresAt | date: 'medium' }}</p>
      </div>

      <div class="field">
        <label for="otpCode">One-Time Password</label>
        <input
          id="otpCode"
          type="text"
          pInputText
          [(ngModel)]="otpCode"
          maxlength="6"
          placeholder="Enter 6-digit OTP" />
      </div>

      <div class="form-actions">
        <p-button
          label="Verify OTP"
          styleClass="auth-button primary-action"
          (onClick)="onVerifyOtp()"
          [loading]="isLoading">
        </p-button>

        <p-button
          label="Resend OTP"
          styleClass="auth-button secondary-action"
          [outlined]="true"
          [disabled]="!canResendOtp()"
          [loading]="isLoading"
          (onClick)="onResendOtp()">
        </p-button>
      </div>

      <button type="button" class="text-link" (click)="onCancelOtp()">
        Cancel supplier login
      </button>
    </div>
  </div>
</div>
